export enum MileagePlanProfileLookupStatus {
  SUCCESS,
  PARTIAL_FAILURE,
  TIMEOUT,
  NO_DATA_RETURNED,
  BAD_REQUEST,
  SYSTEM_FAILURE,
  UNCAUGHT,
}
